// extracted by mini-css-extract-plugin
export default {"codes":"bulkConfirmPaymentsForm_codes__ZfsI9"};